import i18nService from 'common/services/i18nService';
import { isQuestion, isQuestionReview, isQuestionSet, isSection } from 'common/util/shared/sharedUtils';

const newAuthorUIService = {
    isNewAuthorUIEnabled: () => window.marketplaceProperties.ENABLE_AUTHOR_2025_UI,
    isItemBankStatusRulesEanabled: () => window.marketplaceProperties.ENABLE_ITEM_BANK_STATUS_RULES,
    contextName: (defaultTitle?: string) => {
        if (!newAuthorUIService.isNewAuthorUIEnabled()) {
            return defaultTitle;
        }

        if (isQuestionSet()) {
            return 'Question Set';
        }

        if (isSection()) {
            return 'Content Block';
        }

        if (isQuestion() || isQuestionReview()) {
            return 'Question';
        }

        return '';
    },

    editorUrlLanguage: (activeContentLanguage?: string): string | undefined => (
        newAuthorUIService.isNewAuthorUIEnabled() && activeContentLanguage
            ? i18nService.toInsperaLocale(i18nService.toIetfLocale(activeContentLanguage))
            : undefined
    ),
};

export default newAuthorUIService;
